import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  header: {
    paddingTop: '0px',
    fontSize: 20,
    fontWeight: 600
  },
  descriptionContainer_contactDetails: {
    marginBottom: '2em'
  },
  descriptionContainer_accessRoles: {
    marginBottom: 0
  },
  descriptionContainer_default: {
    marginBottom: '1em'
  },
  description: {
    display: 'flex',
    marginTop: '7px',
    fontSize: 14
  },
  radioContainer: {
    '& span': {
      marginTop: '-17px',
      fontSize: '14px'
    }
  },
  gridItem: {
    height: 'calc(100vh - 400px)'
  },
  gridLarge: {
    maxWidth: '47.83333%',
    flexBasis: '47.83333%',
    display: 'flex',
    flexDirection: 'row'
  },
  formCheckBox: {
    marginTop: '26px'
  },
  addLabel: {
    cursor: 'pointer',
    color: '#2962FF',
    textDecoration: 'underline',
    marginLeft: '2px',
    verticalAlign: 'middle'
  },
  closeIcon: {
    paddingTop: '25px'
  },
  addIcon: {
    verticalAlign: 'middle',
    color: '#2962FF'
  },
  ccInput: {
    width: '100%'
  },
  stepper: {
    backgroundColor: '#FFFFFF',
    padding: '0 0 0px',
    display: 'inline-flex'
  },
  leftWrapper: {
    flexGrow: 1
  },
  button: {
    paddingBlock: '0px',
    paddingInline: '10px'
  },
  paddingBlockButton: {
    paddingBlock: '0px',
    paddingInline: '10px',
    marginLeft: 'auto'
  },
  backButton: {
    border: '1px solid #E0E0E0',
    padding: 0,
    '& span': {
      padding: 0
    }
  },
  saveButton: {
    border: '1px solid #E0E0E0',
    '& span': {
      padding: 0
    }
  },
  root: {
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  dialogContent: {
    display: 'flex',
    flex: 1,
    padding: '0px'
  },
  stepperContainer: {
    backgroundColor: '#FFFFFF',
    padding: '11px 8px',
    height: '24px',
    borderBottom: '1px solid #E0E0E0'
  },
  stepContainer: {
    // display: 'flex',
    width: '100%',
    padding: '16px',
    overflowX: 'auto',
    '& .simple-form': {
      width: '100%',
      height: 'unset'
    }
  },
  headerContainer: {
    marginBottom: '1em'
  },
  progress: {
    position: 'absolute',
    top: '25%',
    left: '55%'
  },
  saveAndCloseContainer: {
    display: 'flex',
    gap: '5px',
    marginLeft: 'auto'
  },
  formGroup: {
    marginBlock: '16px'
  }
});
